// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_8u-3";
export var contentContainer = "_8u-0";
export var editorContainer = "_8u-1";
export var quillInputForm = "_8u-2";
export var zoneDivider = "_8u-4";